<template>
    <div class="login d-flex flex-column align-items-center h-80">
        <a href="/">
            <svg class="mb-2 mt-5" height="85" width="122">
                <use xlink:href="#symbol-logo-darker"></use>
            </svg>
        </a>

        <div class="build">
            <h2 class="auth-text text-center">Sign in to manage your account.</h2>
            <p class="text-center login-intro">Please enter your Partner account details for <strong>{{ tenant + '.' + domain }}</strong>.</p>

            <validationObserver ref="observer" v-slot="{ handleSubmit }">
                <form autocomplete="off" class="w-100" @submit.prevent="handleSubmit(); submitForm();">
                    <div class="mb-3">
                        <ValidationProvider v-slot="{ errors }" name="domain" rules="required|subdomain_format">
                            <div class="input-group">
                                <input v-model="data.tenant" :class="{'is-danger': errors[0] || serverErrors.tenant}" aria-describedby="basic-addon2"
                                       aria-label="Domain"
                                       class="form-control" name="tenant" placeholder="Your domain" type="text" @keydown="serverErrors = []">
                            </div>
                            <span v-if="errors.length > 0 && !serverErrors.tenant" class="invalid-feedback d-inline-block">{{ errors[0] }}</span>
                            <span v-if="serverErrors.tenant" class="invalid-feedback d-inline-block">{{ serverErrors.tenant[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="mb-3">
                        <ValidationProvider v-slot="{ errors }" name="email" rules="required|email">
                            <div class="input-group">
                                <input v-model="data.email" :class="{'is-danger': errors[0] || serverErrors.email}" aria-describedby="basic-addon2"
                                       aria-label="Email"
                                       class="form-control" name="email" placeholder="Your email" type="email" @keydown="serverErrors = []">
                            </div>
                            <span v-if="errors.length > 0 && !serverErrors.email" class="invalid-feedback d-inline-block">{{ errors[0] }}</span>
                            <span v-if="serverErrors.email" class="invalid-feedback d-inline-block">{{ serverErrors.email[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="mb-3">
                        <ValidationProvider v-slot="{ errors }" name="password" rules="required">
                            <div class="input-group">
                                <input v-model="data.password" :class="{'is-danger': errors[0] || serverErrors.password}" aria-describedby="basic-addon2"
                                       aria-label="Password"
                                       class="form-control" name="password" placeholder="Your password" type="password" @keydown="serverErrors = []">
                            </div>
                            <span v-if="errors.length > 0 && !serverErrors.password" class="invalid-feedback d-inline-block">{{ errors[0] }}</span>
                            <span v-if="serverErrors.password" class="invalid-feedback d-inline-block">{{ serverErrors.password[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <button class="btn btn-secondary w-100 text-white" type="submit">Continue</button>
                </form>
            </validationObserver>

            <div class="d-flex flex-column align-items-center justify-content-center">
                <p class="login-text mb-2">Don’t know your workspace URL?</p>
				<a href="/find-workspace" class="login-link">Find your workspace</a>

                <p class="login-text mb-2">Looking to create a workspace instead?</p>
                <a class="login-link" href="/register">Sign up here</a>
            </div>
        </div>
    </div>
</template>

<script>
import {normaliseSubdomain} from '../helpers/subdomain'

export default {
	props: {
		domain: {
			required: true
		}
	},

	data: function () {
		return {
			data: {
				tenant: '',
				email: '',
				password: ''
			},
			serverErrors: [],
			publicPath: process.env.MIX_APP_URL
		}
	},

    computed: {
        tenant: function () {
            return window.location.pathname.split('/')[1]
        }
    },

	watch: {
		'data.tenant' (value) {
			const normalised = normaliseSubdomain(value)
			if (normalised !== value) {
				this.data.tenant = normalised
			}
		}
	},

	methods: {
		submitForm: function () {
			this.$refs.observer.validate().then(async result => {
				if (result) {
					this.serverErrors = []

					try {
                        this.data.tenant = this.data.tenant
                        const response = await axios.post(`/${this.data.tenant}/login`, this.data)

						// Redirect to the dashboard
						window.location.href = `/${this.data.tenant}/dashboard`
                        
					} catch (error) {
						if (error.response && error.response.status === 422) {
							this.serverErrors = error.response.data.errors
						} else {
							console.error(error)
						}
					}
				}
			})
		}
	}
}
</script>

<style scoped>
.is-danger {
    border: 1px solid #e3342f !important;
}
</style>


